import React from "react";

function SvgIcMapPoi034(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M15.938 20.479c-4.007 0-7.66-2.037-7.66-5.923 0-3.891 3.653-7.043 7.66-7.043s7.66 3.152 7.66 7.043c0 3.886-3.652 5.923-7.66 5.923m0-14.51C10.197 5.97 6 9.845 6 16.012c0 5.46 3.291 9.105 8.028 9.87V22.97h.634v-.003h2.667v.003h.7v2.884c4.666-.827 7.971-4.449 7.971-9.84 0-6.168-4.32-10.044-10.062-10.044M18 14.16h-4c-.552 0-1-.459-1-1.024 0-.566.448-1.024 1-1.024h4c.553 0 1 .458 1 1.024 0 .565-.447 1.023-1 1.023zm-2 3.07c.752 0 1.407.428 1.749 1.056-.533.093-1.131.146-1.801.146-.631 0-1.196-.047-1.706-.13.34-.637 1-1.071 1.758-1.071zm-1.618-7.165a1.992 1.992 0 001.729 1.024c.739 0 1.383-.413 1.73-1.024H19l2.002 6.497a4.195 4.195 0 01-1.333 1.088c-.616-1.45-2.028-2.467-3.669-2.467-1.657 0-3.082 1.038-3.689 2.511a4.316 4.316 0 01-1.318-1.013L13 10.064z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi034;
